import React, { FC } from 'react';
import { Orientation } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { CustomStepper } from '../Partials/Stepper/CustomStepper';
import { WizardStepperTypeEnum } from '../../contexts/ClientSideWizard/types';
import { GenericStepper } from '../Partials/Stepper/GenericStepper';

export type ClientSideWizardStepperProps = {
  type?: WizardStepperTypeEnum;
  totalSteps: number;
  stepperConfig: GenericObject[];
  totalStepsCompleted: number;
  size?: 'small' | 'large';
  ariaLabel?: string;
  dataTestID?: string;
  orientation?: Orientation;
  labelOrientation?: Orientation;
  hideInactiveLabelOnMobile?: boolean;
  hideStepperIndicatorOnStepIndex?: number[];
  externalStepperWrapperClasses?: string;
  externalStepperClasses?: string;
};
//TODO: add dynamic classes prop
const ClientSideWizardStepper: FC<ClientSideWizardStepperProps> = ({
  type = WizardStepperTypeEnum.generic,
  stepperConfig,
  totalSteps,
  totalStepsCompleted,
  size,
  dataTestID,
  ariaLabel,
  orientation,
  labelOrientation,
  hideInactiveLabelOnMobile,
  hideStepperIndicatorOnStepIndex,
  externalStepperWrapperClasses,
  externalStepperClasses,
}) => {
  switch (type) {
    case WizardStepperTypeEnum.custom:
      return (
        <CustomStepper
          size={size}
          ariaLabel={ariaLabel}
          dataTestID={dataTestID}
          totalSteps={totalSteps}
          orientation={orientation}
          stepperConfig={stepperConfig}
          totalStepsCompleted={totalStepsCompleted}
          labelOrientation={labelOrientation}
          hideInactiveLabelOnMobile={hideInactiveLabelOnMobile}
          hideStepperIndicatorOnStepIndex={hideStepperIndicatorOnStepIndex}
          externalStepperWrapperClasses={externalStepperWrapperClasses}
          externalStepperClasses={externalStepperClasses}
        />
      );
    case WizardStepperTypeEnum.generic:
      return (
        <GenericStepper
          size={size}
          ariaLabel={ariaLabel}
          dataTestID={dataTestID}
          totalSteps={totalSteps}
          orientation={orientation}
          stepperConfig={stepperConfig}
          totalStepsCompleted={totalStepsCompleted}
          labelOrientation={labelOrientation}
          hideInactiveLabelOnMobile={hideInactiveLabelOnMobile}
          hideStepperIndicatorOnStepIndex={hideStepperIndicatorOnStepIndex}
          externalStepperWrapperClasses={externalStepperWrapperClasses}
          externalStepperClasses={externalStepperClasses}
        />
      );

    default:
      return <span>No wizard type provided</span>;
  }
};

export { ClientSideWizardStepper };
